import { helperSlice } from '.';

export const { setIsLoadingAction, setMessageAction } = helperSlice.actions;
